import { downloadFile } from "helpers/downloadFile";

// Escape a single CSV field per RFC 4180: wrap in quotes when it contains a
// comma, quote, or newline, and double any embedded quotes.
function escapeCsvField(value) {
  const str = value == null ? "" : String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

/**
 * Build CSV text from a header row and an array of row arrays.
 */
export function toCsv(header, rows) {
  return [header, ...rows].map((row) => row.map(escapeCsvField).join(",")).join("\r\n");
}

/**
 * Generate a CSV file from a header + rows and trigger a browser download.
 */
export function downloadCsv(filename, header, rows) {
  const csv = toCsv(header, rows);
  const blob = new Blob(["﻿", csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  downloadFile(url, filename.endsWith(".csv") ? filename : `${filename}.csv`);
}
